<template>
	<div class="animated fadeIn">
		<b-row class="justify-content-center">
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6" class="font-weight-bold">
								Detalle de Minuta
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body v-if="summary">
						<b-row class="justify-content-start">
							<b-col md="4" lg="3">
								<h6><span class="text-info">Número: </span> {{ summary.Reference }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Tema: </span> {{ summary.Name }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha Creación: </span>
									{{ summary.CreatedOn | dateFormatFull }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Inicio: </span>
									{{ summary.StartDate | dateFormatFull }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Final: </span>
									{{ summary.EndDate | dateFormatFull }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Gerencia Responsable: </span>
									{{ summary.ResponsibleManagement }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Departamento: </span> {{ summary.Department }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Expositor: </span> {{ summary.Exponent }}</h6>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-details
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Detalles</strong>
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!loading" class="when-closed fa fa-plus-circle"
								   aria-hidden="true"></i>
								<i v-if="!loading" class="when-opened fa fa-minus-circle"
								   aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-details">
						<b-card-body class="table-responsive">
							<b-table v-if="summary"
									 :items="summary.SummaryItems"
									 :fields="summaryItemsTableFields"
									 :busy="loading"
									 :current-page="currentPage"
									 :per-page="perPage"
									 show-empty
									 striped
									 empty-filtered-text="No hay detalles disponibles"
									 empty-text="No hay detalles disponibles"
									 head-variant="light">

								<div slot="LimitDate" slot-scope="item">
									{{ item.item.LimitDate | dateFormat }}
								</div>

								<div slot="Detail" slot-scope="item">
									<b-button @click="item.toggleDetails" variant="link">
										{{ item.detailsShowing ? 'Ocultar' : 'Ver' }}
									</b-button>
								</div>

								<template #row-details="row">
									<b-card>
										<b-row class="mb-2">
											<b-col sm="3" class="text-sm-right"><b>Acuerdos Tomados:</b></b-col>
											<b-col>{{ row.item.Details }}</b-col>
										</b-row>
									</b-card>
								</template>

								<template v-slot:table-busy>
									<div class="text-center text-info my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>
								</template>
							</b-table>
							<nav class="d-flex justify-content-center" v-if=" summary && summary.SummaryItems.length > perPage">
								<b-pagination
									:total-rows="summary.SummaryItems.length"
									:per-page="perPage"
									v-model="currentPage"
									prev-text="<<"
									next-text=">>"
									hide-goto-end-buttons/>
							</nav>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<go-back-component></go-back-component>
	</div>
</template>

<script>
import GoBackComponent from "@/components/GoBackComponent";
import {mapActions} from "vuex";

export default {
	name: "SummaryDetail",
	components: {
		GoBackComponent
	},
	data: function () {
		return {
			loading: false,
			summary: '',
			currentPage: 1,
			perPage: 10,
			summaryItemsTableFields: {
				Name: {
					label: 'Tema Tratado'
				},
				Status: {
					label: 'Estado'
				},
				AssingBy: {
					label: 'Asignado a'
				},
				LimitDate: {
					label: 'Fecha Máxima'
				},
				Detail: {
					label: 'Detalles'
				}
			}
		}
	},
	mounted() {
		const summaryId = this.$route.params.summaryId;
		this.loading = true;

		this.getSummaryDetail(summaryId)
			.then((summary) => {
				console.log(summary);
				this.summary = summary;
			})
			.catch((err) => {

			})
			.finally(() => {
				this.loading = false;
			})
	},
	methods: {
		...mapActions([
			'getSummaryDetail'
		])
	}
}
</script>

<style scoped>

</style>
